import React from "react";

const NUMBERS = [
  { v: "1,500+",  l: "SITES SERVED" },
  { v: "~75M L",  l: "PURIFIED / MONTH" },
  { v: "97%+",    l: "UPTIME · SLA SITES" },
  { v: "Priority", l: "EMERGENCY DISPATCH" },
  { v: "100%",    l: "INCIDENT RESOLUTION" },
];

export default function ByTheNumbers() {
  const ts = new Date().toISOString().replace("T", " · ").slice(0, 19) + " SAST";
  return (
    <section
      className="border-y"
      style={{ background: "#FFFFFF", color: "#0C2A40", borderColor: "rgba(12,42,64,0.08)" }}
      data-testid="by-the-numbers"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-20 py-10 md:py-14">
        <div
          className="font-mono uppercase mb-6 md:mb-8 text-center md:text-left"
          style={{ fontSize: "0.6rem", letterSpacing: "0.22em", color: "#5B6877" }}
        >
          Live ops · last updated {ts}
        </div>
        <div className="grid grid-cols-2 md:grid-cols-5 gap-y-10 md:gap-y-0">
          {NUMBERS.map((n) => (
            <div key={n.l} className="px-2 md:px-6 text-center md:text-left">
              <div
                className="font-display"
                style={{
                  fontSize: "clamp(2rem, 3.2vw, 2.6rem)",
                  fontWeight: 700,
                  color: "#0C2A40",
                  letterSpacing: "-0.025em",
                  lineHeight: 1,
                }}
              >
                {n.v}
              </div>
              <div
                className="font-mono uppercase mt-3"
                style={{
                  fontSize: "0.6rem",
                  letterSpacing: "0.18em",
                  color: "#5B6877",
                  lineHeight: 1.4,
                }}
              >
                {n.l}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
